import { useEffect, useState } from 'react';
import { Chip } from '@mui/material';
import moment from 'moment';
import BrazilMoney from 'utils/BrazilMoney';
import { useSelector } from 'react-redux';
import PurchasesService from 'services/PurchasesService';

export function usePurchases() {
  const [purchases, setPurchases] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [errors, setErrors] = useState([]);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Nome',
      render: (rowData) => {
        if (rowData.items.length) {
          const supplyName = rowData?.items?.map((item) => item.supply.name).join(', ');
          return <p>{supplyName}</p>;
        }
        const remittanceName = rowData?.lots?.map((item) => item.name).join(', ');
        return <p>{remittanceName}</p>;
      },
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Data',
      field: 'date',
      type: 'date',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => (
        <p>{moment(rowData.date.substring(0, 10)).format('DD/MM/YYYY')}</p>
      ),
    },
    {
      title: 'Fornecedor',
      field: 'bill.stakeholder.name',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Status',
      field: 'bill.status',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => (
        <Chip
          style={{
            backgroundColor:
              rowData.bill.status === 'pendente' ? '#F44336' : '#0B8846',
            color: '#fff',
            fontWeight: 'bolder',
          }}
          label={
            rowData.bill.status[0].toUpperCase() + rowData.bill.status.substr(1)
          }
        />
      ),
    },
    {
      title: 'Tipo',
      render: (rowData) => (
        <>
          {/* Renderização condicional do tipo de compra daquela linha */}
          {rowData.items.length ? <div> Insumo </div> : <div>Remessa</div>}
        </>
      ),
      customFilterAndSearch: (term, rowData) => (rowData.items.length
        ? 'insumo'.includes(term.toLowerCase())
        : 'remessa'.includes(term.toLowerCase())),
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Parcelas',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => {
        const pay = rowData.bill.parts.filter((part) => part.pay);
        const parts = rowData.bill.parts.length;
        return (
          <p>{`${pay.length}/${parts}`}</p>
        );
      },
    },
    {
      title: 'Preço Total',
      field: 'total',
      render: (rowData) => (
        <span>
          <BrazilMoney value={rowData.total} />
        </span>
      ),
      hideFilterIcon: true,
    },
  ];

  const columnsForExport = [
    {
      title: 'Data',
      field: 'date',
    },
    {
      title: 'Fornecedor',
      field: 'stakeholder',
    },
    {
      title: 'Status',
      field: 'status',
    },
    {
      title: 'Descrição',
      field: 'description',
    },
    {
      title: 'Quantidade de parcelas',
      field: 'parts_quantity',
    },
    {
      title: 'Preço Total',
      field: 'total',
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await PurchasesService.purchaseList();
        if (response.length === 0) {
          setOpenProgress(true);
        }
        if (response) {
          setPurchases(response);
        }
      } catch (err) {
        setErrors((prev) => [err.message, ...prev]);
      }
    }

    loadData();
  }, [nameProperty]);

  useEffect(() => {
    async function loadDataExport() {
      try {
        const response = await PurchasesService.purchaseListExport();
        if (response.length === 0) {
          setOpenProgress(true);
        }
        if (response) {
          setExportData(response);
        }
      } catch (err) {
        setErrors((prev) => [err.message, ...prev]);
        setOpenProgress(true);
      }
    }

    loadDataExport();
  }, [nameProperty]);

  return {
    purchases,
    openProgress,
    columns,
    columnsForExport,
    exportData,
    errors,
  };
}
